export default "__VITE_ASSET__D$8s4boj__"